const B2T_COUNTRY_DROPLIST_STORAGE_KEY = 'b2tdiffCountryDroplist';

const getStorageKeyForCountryDroplist = clientId =>
  (`${B2T_COUNTRY_DROPLIST_STORAGE_KEY}|${window.location.pathname}|${clientId}`);

export const getCountryFromLocalStorage = clientId => {
  const country = localStorage.getItem(getStorageKeyForCountryDroplist(clientId));
  return country ? JSON.parse(country) : null;
};

export const setCountryToLocalStorage = (clientId, country) =>
  localStorage.setItem(getStorageKeyForCountryDroplist(clientId), JSON.stringify(country));
